module.exports = __webpack_public_path__ + "static/media/icon_sachet.28dbca9f.svg";